module.exports = __webpack_public_path__ + "static/img/滚筒与护帮板状态监测.5bc5571e.png";